import * as React from "react";
import { Game } from "./Game";
import { IAppState } from "./App";
import { GameStage } from "./GameStage";
import { InvestigatorPortraitComponent } from "./InvestigatorPortrait";
import { Stock } from "./Stock";

export interface ICampaignLogProps {
    state: IAppState;
    onClose: () => void;
}
export class CampaignLogComponent extends React.Component<ICampaignLogProps, any> {
    render() {

        const campaign = Game.getCampaign(this.props.state.scenarioState);

        const investigators = this.props.state.scenarioState.investigators.map((inv, i) => {
            let assets: JSX.Element[] = null;
            if (inv.freeCards && inv.freeCards.length) {
                assets = inv.freeCards.map((fc, i) => {
                    const card = Stock.getCard(fc);
                    return (<li key={i}>{card.name}</li>);
                });
            }
            return (<div key={i} className="col col-md-3 investigator-log">
                <InvestigatorPortraitComponent investigator={inv} index={i} disableToolbar={true} onChanged={() => { }} />
                <div className="row border-top">
                    <div className="col col-sm-12 " >
                        <div className="log-form-title">Investigator name</div>
                        <div className="log-form-value">{inv.card.name}</div>
                    </div>
                </div>
                <div className="row border-top">
                    <div className="col col-sm-12">
                        <div className="log-form-title">Unspent experience</div>
                        <div className="log-form-value">{inv.experience ? inv.experience : 0}</div>
                    </div>
                </div>
                <div className="row border-top">
                    <div className="col col-sm-6 border-right">
                        <div className="log-form-title">Physical trauma</div>
                        <div className="log-form-value">{inv.physicalTrauma}</div>
                    </div>
                    <div className="col col-sm-6">
                        <div className="log-form-title">Mental trauma</div>
                        <div className="log-form-value">{inv.mentalTrauma}</div>
                    </div>
                </div>
                <div className="row border-top">
                    <div className="col col-sm-12">
                        <div className="log-form-title">Earned story assets/weaknesses</div>
                        <div className="log-form-value"><ul>{assets}</ul></div>
                    </div>
                </div>
            </div>);
        });
        const scenarios = campaign.scenarios.map((s, i) => {
            let cn = "glyphicon ";
            if (this.props.state.scenarioState.scenarioIndex > i || this.props.state.scenarioState.scenarioIndex === i && this.props.state.stage > GameStage.ScenarioPlay) {
                cn += "glyphicon-ok";
            }
            return (<li key={i}><i className={cn}></i> {s.name}</li>);
        });
        let killedAndInsaneInvestigators: JSX.Element[] = null;
        if (this.props.state.scenarioState.killedAndInsaneInvestigators && this.props.state.scenarioState.killedAndInsaneInvestigators.length) {
            killedAndInsaneInvestigators = this.props.state.scenarioState.killedAndInsaneInvestigators.map((inv, i) => {
                return (<li key={i}>{inv.card.name}</li>);
            });
        }
        let campaignNotes: JSX.Element[] = null;
        if (this.props.state.scenarioState.campaignNotes && this.props.state.scenarioState.campaignNotes.length) {
            campaignNotes = this.props.state.scenarioState.campaignNotes.map((cng, i) => {
                const cns = cng.notes.filter(cn => !cn.hidden).map((cn, j) => {
                    return (<li key={j} className={(cn.crossedOut ? "crossed-out" : null)}>{cn.note}</li>);
                });
                return (<div key={i}><h2>{cng.title}</h2><ul>{cns}</ul></div>);
            });
        }

        return (
            <div className="container">
                <div className="col col-md-12 p-t-30">
                    <div className="summary summary-campaign-log ">
                        <div className="content-box">
                            <div className="row">
                                <div className="col col-md-12">
                                    <h1>Campaign Log:</h1>
                                    <h2>{campaign.name}</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col col-md-12 text-center">
                                    <h3>Investigators</h3>
                                </div>
                            </div>
                            <div className="row table-style">
                                {investigators}
                            </div>
                            <div className="row">
                                <div className="col col-md-6">
                                    <div>
                                        <h2>Scenarios</h2>
                                        <ul>{scenarios}</ul>
                                    </div>
                                    <div>
                                        <h2>Killed and insane investigators</h2>
                                        <ul>{killedAndInsaneInvestigators}</ul>
                                    </div>
                                </div>
                                <div className="col col-md-6">
                                    {campaignNotes}
                                </div>
                            </div>
                            <div className="clearfix">
                                <div className="pull-right">
                                    <button onClick={() => this.props.onClose()}>Continue</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
